// Imports => Moment
import moment from 'moment';
import 'moment/locale/nl';

// Imports => Config
import { getLocale, setLocale } from '@config/moment.js';

export const AcFormatDate = (input, from = 'DD-MM-YYYY', to = 'DD MMM Y') => {
	// Set and Get locale settings
	setLocale();
	const locale = getLocale();

	// Verify valid date / moment object
	if (!moment(input, from).isValid()) return input;

	// Format input
	const output = moment(input, from)
		.locale(locale)
		.format(to);

	return output;
};

export const AcGetTimeDifference = (
	time,
	now = moment(),
	format = 'HH:mm',
	ms = false
) => {
	setLocale();

	const start = moment(now).isValid() ? moment(now) : moment();
	const end = format ? moment(time, format) : moment(time);
	const diff = moment.duration(start.diff(end));

	if (ms) return diff.asMilliseconds();
	return diff;
};

export default AcFormatDate;
